import React, { ReactElement } from 'react';
import IconProps from '../IconProps';

export default function IconDownload({ className }: IconProps): ReactElement {
    return (
        <svg
            className={className}
            width='16px'
            height='17px'
            viewBox='0 0 16 17'
            version='1.1'
            xmlns='http://www.w3.org/2000/svg'
        >
            <title>ic_download</title>
            <desc>Created with Sketch.</desc>
            <g
                id='Rules'
                stroke='none'
                strokeWidth='1'
                fill='none'
                fillRule='evenodd'
                strokeLinecap='round'
                strokeLinejoin='round'
            >
                <g id='Icons' transform='translate(-464.000000, -764.000000)' stroke='#000000'>
                    <g id='ic_download' transform='translate(460.000000, 760.000000)'>
                        <g id='ic_downwards'>
                            <g
                                transform='translate(12.000000, 12.000000) rotate(-90.000000) translate(-12.000000, -12.000000) '
                                strokeWidth='2'
                            >
                                <line
                                    x1='7'
                                    y1='12'
                                    x2='19'
                                    y2='12'
                                    id='Line'
                                    transform='translate(13.000000, 12.000000) scale(-1, 1) translate(-13.000000, -12.000000) '
                                />
                                <line
                                    x1='5'
                                    y1='18'
                                    x2='5'
                                    y2='6'
                                    id='Line-Copy'
                                    transform='translate(4.500000, 11.500000) scale(-1, 1) translate(-4.500000, -11.500000) '
                                />
                                <line
                                    x1='14'
                                    y1='12'
                                    x2='7'
                                    y2='5'
                                    id='Line'
                                    transform='translate(10.500000, 8.000000) scale(-1, 1) translate(-10.500000, -8.000000) '
                                />
                                <line
                                    x1='15'
                                    y1='12'
                                    x2='8'
                                    y2='19'
                                    id='Line'
                                    transform='translate(11.000000, 15.500000) scale(-1, 1) translate(-11.000000, -15.500000) '
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
